import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

import {
  ViewsCnt,
  VideoTitle,
  AboutVideoContainer,
} from '../HomePageVideoItem/styledComponents'
import {GameVidItem, GameThumbnailImg, GameLinkEl} from './styledComponents'

const GameVideoItem = props => {
  const {details} = props
  const {id, title, thumbnailUrl, viewCount} = details
  return (
    <NxtWatchContext.Consumer>
      {value => {
        const {darkMode} = value
        return (
          <GameLinkEl to={`videos/${id}`}>
            <GameVidItem>
              <GameThumbnailImg src={thumbnailUrl} alt="video thumbnail" />
              <AboutVideoContainer>
                <VideoTitle darkMode={darkMode}>{title}</VideoTitle>
                <ViewsCnt>{viewCount} Watching Worldwide</ViewsCnt>
              </AboutVideoContainer>
            </GameVidItem>
          </GameLinkEl>
        )
      }}
    </NxtWatchContext.Consumer>
  )
}

export default GameVideoItem
